// Themed marquee from create-friend (valentines). Not used in the trans
// lander design — exporting a no-op so existing imports keep compiling.
const AnimatedTapeAuth = () => null;

export default AnimatedTapeAuth;
